export enum CursorType {
  default = 'default',
  crosshair = 'crosshair',
  help = 'help',
  move = 'move',
  grab = 'grab',
  grabbing = 'grabbing',
  pointer = 'pointer',
  pickUp = 'cdn/icons/cursorPickUp.svg',
  dropDown = 'https://svgshare.com/i/GGA.svg',
  destination = 'cdn/icons/destination.svg',
}
